import axiosInstance from "./index.services";

export async function uploadToGallery({formData} : {formData : FormData}){
  const response = await axiosInstance.post("/custom-gallery/", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response;
}

export async function ImageUploadGiveAway({IsGiveaway, GiveawayImg} : {IsGiveaway?: string, GiveawayImg: string}){
  const response = await axiosInstance.post("/giveaway/", {
    is_giveaway: IsGiveaway,
    giveaway_image: GiveawayImg
  }, {
    headers: { "Content-Type": "application/json" },
  });
  return response;
}

export async function ToggleShowGiveawayTemplate({id, IsShow} : {id: string| number, IsShow: boolean}){
  const response = await axiosInstance.patch(`/giveaway-templates/${id}/`, {
    is_show: IsShow, 
  }, {
    headers: { "Content-Type": "application/json" },
  });
  return response;
}

export async function ActiviteGiveAway({active, Image} : {active: boolean, Image?: string}){
  const response = await axiosInstance.post(`/giveaway/`, {
    is_giveaway: active,
    giveaway_image: Image,
  }, {
    headers: { "Content-Type": "application/json" },
  });
  return response;
}

export async function GetActiveGiveAway(){
  const response = await axiosInstance.get(`/giveaway/`);
  return response;
}

